export const numericAscending = (a, b) => a - b;
export const numericDescending = (a, b) => b - a;

export const caseInsensitive = (a, b) => a.localeCompare(b);

export const sortOn = (field, comparer) => (a, b) =>
  comparer(a[field], b[field]);

export const ascending = 1;
export const descending = -1;

export const dualSort = (
  field1,
  comparer1,
  direction1,
  field2,
  comparer2,
  direction2
) => (a, b) =>
  (comparer1(a[field1], b[field1]) * direction1 ||
    comparer2(a[field2], b[field2])) * direction2;
